import React from 'react'
import { Link } from 'gatsby'

import { getFeatured } from '@helpers/helper.developments'
import { Development, DevelopmentMediacore, RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import useQueryDevelopments from '@hooks/useQueryDevelopments'

const Summary_Devs_1 = (props: RealEstateDataPageComponentData) => {
  const { isDemo, global_data } = props
  const { title, button, columns, alignCenter, titleSecondary } = isDemo ? props : props

  const devCard = global_data.content?.cardsDevelopments?.type_id ?? '1'
  const tokkoKey = global_data.pageConfig.keys.tokko
  const { data: allDevelopmentsData, isLoading } = useQueryDevelopments(tokkoKey)

  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  return (
    <section
      className={
        'p-y-config ' +
        (columns == '2' ? 'is-double' : '') +
        (!isLoading &&
        (getFeatured(allDevelopmentsData!)?.length === 0 ||
          getFeatured(allDevelopmentsData!) === undefined)
          ? ' d-none'
          : '')
      }
      id="featured-devs"
    >
      <Container
        fluid
        className=""
      >
        <h2
          className={
            'section-title pb-0 pb-lg-5 ' +
            (alignCenter ? 'text-center' : 'text-left') +
            (titleSecondary ? ' text-secondary ' : '')
          }
        >
          {title}
        </h2>
      </Container>
      <div className="devs mt-4">
        <Container fluid>
          <>
            <Row className={'no-gutters'}>
              {allDevelopmentsData
                ? getFeatured(allDevelopmentsData).map(
                    (development: Development | DevelopmentMediacore, index: number) =>
                      index < (columns == '2' ? 2 : 3) && (
                        <Col
                          key={index}
                          className={'mb-4 mb-lg-0 p-lg-3'}
                          md={
                            columns == '2'
                              ? 6
                              : getFeatured(allDevelopmentsData)?.length >= 3
                              ? 4
                              : getFeatured(allDevelopmentsData)?.length === 1
                              ? 12
                              : 6
                          }
                        >
                          <Card
                            development={development}
                            global_data={global_data}
                          />
                        </Col>
                      ),
                  )
                : ''}
            </Row>
          </>
          {isLoading && (
            <>
              <Row>
                {[1, 2, 3].map((index) => (
                  <Col
                    key={index}
                    lg={4}
                  >
                    <Card
                      skeleton={true}
                      global_data={global_data}
                    />
                  </Col>
                ))}
              </Row>
            </>
          )}
          {button?.link! && (
            <Row>
              <Col className="text-center">
                <Link
                  to={button?.link!} //CONSULTAR
                  className="mt-5 d-inline-block btn btn-primary"
                >
                  {button?.value}
                </Link>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </section>
  )
}

export default Summary_Devs_1
